import { render } from "./Dividend_Processing.vue?vue&type=template&id=2bbb4a9e"
import script from "./Dividend_Processing.vue?vue&type=script&lang=js"
export * from "./Dividend_Processing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__